import { FaGithub, FaExternalLinkAlt, FaCode, FaDocker, FaPython, FaCloud, FaLinkedin, FaReact, FaBook } from "react-icons/fa";
import { FaFlutter } from "react-icons/fa6";

export const Icon = {
    Github: FaGithub,
    Link: FaExternalLinkAlt,
    Code: FaCode,
    Docker: FaDocker,
    Python: FaPython,
    Cloud: FaCloud,
    Flutter: FaFlutter,
    Riverpod: FaFlutter,
    React: FaReact,
    LinkedIn: FaLinkedin,
    Blog: FaBook,
};

export default Icon;